import BackendUtil from '../utils/backend.util';

export const get = async (params) => {
  const { success, body, error } = await BackendUtil.request.get("/trajectory", { params });
  return success ? { success, payload: body } : { success, error };
};